<template>
	<div
		id="screen-video-player"
		class="responsive-video tw-relative tw-h-full"
		:class="[full_width ? 'tw-w-full' : 'tw-w-9/12 tw-mx-4']"
	>
		<video ref="video" class="max-vh-vw" muted/>
        <audio ref="audio" style="display: none" />
	</div>
</template>

<script>
export default {
	name: 'ScreenVideoPlayer',
	props: {
		full_width: {
			required: false,
			default: true,
		},
    volume: {
      required: true,
      type: String,
    },
	},
  watch: {
    // video.volume is of type double, between 0 and 1, where 1 is max value.
    volume(new_volume) {
      if (this.$refs.audio) {
        this.$refs.audio.volume = parseInt(new_volume) / 100;
      }
    },
  },

    mounted() {
        this.$emit('onMounted');
    }
}
</script>

<style scoped>
.max-vh-vw {
	max-width: 100vw;
	max-height: 100vh;
}
</style>
